import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { ReviewsModel, ReviewEntities } from 'client/data/models/dealer-reviews';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { DealerOverallSalesRating } from './dealer-reviews-overall-rating';

/**
 * Shows dealer overall sales rating.
 * @param vinData
 * @param overallRating
 * @param salesReviews
 * @param dealerReviewLink
 * @returns {ReactElement}
 */
export function DealerReviewsOverallRatingWrapperUI({ overallRating = {}, salesReviews = {}, dealerReviewLink = '' }) {
  const averageRating = get(overallRating, 'salesReview.averageRating');
  const reviews = get(salesReviews, 'newReviews', []);
  const totalCount = get(overallRating, 'salesReview.totalCount', 0);
  const reviewsLength = reviews.length;

  return totalCount && reviewsLength ? (
    <DealerOverallSalesRating average={averageRating} total={totalCount} dealerReviewLink={dealerReviewLink} />
  ) : null;
}

DealerReviewsOverallRatingWrapperUI.propTypes = {
  overallRating: ReviewEntities.OverallRatingEntity,
  salesReviews: ReviewEntities.ReviewsByType,
  dealerReviewLink: PropTypes.string,
};

export const stateToPropsConfig = {
  overallRating: bindToPath(
    ({
      vinData: {
        dealerInfo: { rooftopId },
      },
    }) => `dealershipReviews.id["${rooftopId}"].overallRating`,
    ReviewsModel
  ),
  salesReviews: bindToPath(
    ({
      vinData: {
        dealerInfo: { rooftopId },
      },
    }) => `dealershipReviews.id["${rooftopId}"].sales`,
    ReviewsModel
  ),
};

export const DealerReviewsOverallRatingWrapper = connectToModel(
  DealerReviewsOverallRatingWrapperUI,
  stateToPropsConfig
);
